define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/line/bezier-quadratic',
    'backbone',
    'victor'
], function(
    SVGView,
    BezierQuadraticView,
    Backbone,
    Victor
    ) {
    return Backbone.Model.extend({}, {
        build: function(params) {
            var sourceView = params.sourceView;
            var targetView = params.targetView;
            var sourceCenterPoint = sourceView.getCenterPoint();
            var targetCenterPoint = targetView.getCenterPoint();
            var bendingPoint = params.bendingPoint;
            var offset = params.offset !== undefined ? params.offset : 64;

            if (this.isBended(sourceCenterPoint, targetCenterPoint, sourceView, targetView, bendingPoint)) {
                return this.buildBendedLine(sourceCenterPoint, targetCenterPoint, sourceView, targetView, offset, bendingPoint);
            } else {
                return this.buildStraightLine(sourceCenterPoint, targetCenterPoint, sourceView, targetView, offset, bendingPoint);
            }
        },

        isBended: function(sourceCenterPoint, targetCenterPoint, sourceView, targetView, bendingPoint) {
            var offset = 64;
            var source2target = targetCenterPoint.clone()
                .subtract(sourceCenterPoint);
            var startingPoint = sourceView.getBorderPoint(source2target, offset);
            var endingPoint = targetView.getBorderPoint(source2target.invert(), offset);

            // 制御点から Node を結ぶ直線への垂線の足のベクトル
            var norm = endingPoint.clone().subtract(startingPoint).norm().rotateDeg(90);
            var inner = bendingPoint.clone()
                .subtract(startingPoint).multiply(norm);

            var dLength = inner.x + inner.y;
            // bendingPoint が source と target を結ぶ直線から、垂直方向に
            // 1 より大きく離れていたら bending しているとみなす
            return dLength > 1 || dLength < -1;
        },

        buildStraightLine: function(sourceCenterPoint, targetCenterPoint, sourceView, targetView, offset, bendingPoint){
            var source2target = targetCenterPoint.clone()
                .subtract(sourceCenterPoint);
            var startingPoint = sourceView.getBorderPoint(source2target, offset);
            var endingPoint = targetView.getBorderPoint(source2target.invert(), offset);
            var controlPoint = bendingPoint.clone()
                .subtract(startingPoint.clone().mix(endingPoint, 0.5))
                .multiply(Victor(2, 2))
                .add(startingPoint.clone().mix(endingPoint, 0.5));

            return BezierQuadraticView.Builder()
                .addPoint(startingPoint, controlPoint)
                .addPoint(endingPoint)
                .build();
        },

        buildBendedLine: function(sourceCenterPoint, targetCenterPoint, sourceView, targetView, offset, bendingPoint) {
            /**
             * ユーザビリティのため、bending Point 上を曲線が通過するようにしたい。
             * 2 次の Bezier 曲線の場合、starting, ending Point の中点と
             * control Point を結んだ線の中点を必ず曲線が通過するので、
             * 逆にこの点を bending Point として control Point を逆算する。
             * ただし、実際には曲線の端点は中心点ではなく、border から始まるため、
             * 後から補正することになる。
             *
             * そのため、
             * sourceView, targetView の中心を結んだ線の中心の 2 分点から
             * bending Point に引いたベクトルの長さを 2 倍にした点を
             * 一旦仮の control Point にする。
             */
            var controlPoint = bendingPoint.clone()
                .multiply(Victor(2, 2))
                .subtract(sourceCenterPoint.clone().mix(targetCenterPoint, 0.5));

            /**
             * (仮の) control Point から sourceView, targetView の中心に線を引き
             * それぞれの border(offset あり) と交わった点を
             * starting Point, ending Point とする。
             */
            var startingPoint = sourceView
                .getBorderPoint(
                    controlPoint.clone().subtract(sourceCenterPoint), offset);
            var endingPoint = targetView
                .getBorderPoint(
                    controlPoint.clone().subtract(targetCenterPoint), offset);

            /**
             * starting, ending Point が決まったので、
             * 改めて先の計算を行い control Point を確定させる。
             */
            controlPoint = bendingPoint.clone()
                .multiply(Victor(2, 2))
                .subtract(startingPoint.clone().mix(endingPoint, 0.5));

            return BezierQuadraticView.Builder()
                .addPoint(startingPoint, controlPoint)
                .addPoint(endingPoint)
                .build();
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/center-line-factory.js